require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-summer-at-the-bend.json") })
        }
      }, "path---news-summer-at-the-bend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-summer-at-the-bend!./.cache/json/news-summer-at-the-bend.json
// module id = 848
// module chunks = 231608221292675